<div class="card h-100 mx-auto mb-3" *ngIf="course">

    <a class="custom-course-summary-card-hyperlink card-body" [routerLink]="['./', course.courseUrl]">

        <div class="d-flex flex-column flex-md-row justify-content-start align-items-center h-100 w-100">
            
            <!-- Course icon -->
            <img class="custom-course-summary-card-icon h-100 p-2 me-1" [src]="courseIconPath">
            
            <!-- Course description -->
            <div class="d-flex flex-column justify-content-start align-items-start ms-3">

                <!-- Title -->
                <div class="d-flex flex-row justify-content-start align-items-center">
                    <h3 class="title">{{ course.courseName }}</h3>
                    <!-- <img *ngIf="course.language"
                        class="custom-course-summary-card-language-icon align-self-center ms-2 mb-2 h-100" 
                        [src]="course.language.iconPath"
                        [title]="'Curso en ' + course.language.name.toLowerCase()"> -->
                </div>
                
                <!-- Short description -->
                <p class="w-100" [innerHTML]="courseShortDescription"></p>

                <!-- Requirements -->
                <div *ngIf="courseRequirements"> 
                    <div class="alert alert-warning d-flex flex-row justify-content-start align-items-center border border-warning p-2">
                        <span class="material-icons align-self-center me-2">warning</span>
                        <span class="align-self-center" [innerHTML]="courseRequirements"></span>
                    </div>
                </div>
                
                <!-- Area -->
                <div class="d-flex flex-row justify-content-start align-items-center mb-2"> 
                    <div class="badge p-2" [ngClass]="areaBadgeClass">
                        <img  *ngIf="areaIconPath" class="custom-course-summary-card-area-icon align-self-center me-2 h-100" [src]="areaIconPath">
                        <span class="align-self-center">{{ course.courseArea.name }}</span>
                    </div>
                </div>

                <!-- Classifications -->
                <div class="d-flex flex-row justify-content-start align-items-center mb-2"> 
                    <span *ngFor="let classification of course.classifications"
                        class="badge custom-classification-badge-default me-2" >
                        {{ classification.name }}
                    </span>
                </div>
                
            </div>

        </div>
        
    </a>
      
</div>
